import styled from "styled-components";
import {useAppDispatch} from "../../../hooks";
import {deleteTableRecord} from "../../../features/tableSlice";
import {confirmAction} from "../../util";


export default function DeleteTableRecordButton({pkValue}: { pkValue: string | number }) {


    const dispatch = useAppDispatch();

    const confirmDelete = () => confirmAction({
        message: "Видалити запис із таблиці з айді " + pkValue + "?",
        onConfirm: () => dispatch(deleteTableRecord({id: pkValue}))
    }).then();


    return <Button className={'btn-cmn'} onClick={confirmDelete}>
        Видалити
    </Button>
}

const Button = styled.div`
  width: 100%;
`
